import { Routes } from '@angular/router';
import { PermissionsEnum } from './api/api-reference';
import { ProcessLoginComponent } from './identity/process-login/process-login.component';
import { LoginComponent } from './modules/login/login/login.component';
import { AccountAppearanceComponent } from './modules/account/account-appearance/account-appearance.component';
import { AccountLanguageComponent } from './modules/account/account-language/account-language.component';
import { AccountMenuComponent } from './modules/account/account-menu/account-menu.component';
import { AccountProfileComponent } from './modules/account/account-profile/account-profile.component';
import { AnalysisReportMenuComponent } from './modules/analysis-report/analysis-report-menu/analysis-report-menu.component';
import { FraudulentMetersComponent } from './modules/analysis-report/fraudulent-meters/fraudulent-meters.component';
import { MeterTimeSyncComponent } from './modules/analysis-report/meter-time-sync/meter-time-sync.component';
import { EnergyPerPhaseComponent } from "./modules/analysis-report/energy-per-phase/energy-per-phase.component";
import { EnergyPerPhaseDetailsComponent } from "./modules/analysis-report/energy-per-phase-details/energy-per-phase-details.component";
import { PrePaymentReportComponent } from './modules/analysis-report/pre-payment-report/pre-payment-report.component';
import { AnalyticsComponent } from './modules/analytics/analytics/analytics.component';
import { BillingDataDetailsComponent } from './modules/billing-data/billing-data-details/billing-data-details.component';
import { OnDemandBillingDataComponent } from './modules/billing-data/on-demand-billing-data/on-demand-billing-data.component';
import { HealthCheckComponent } from './modules/core/components/health-check/health-check.component';
import { PrivateLayoutComponent } from './modules/core/components/private-layout/private-layout.component';
import { PublicLayoutComponent } from './modules/core/components/public-layout/public-layout.component';
import { DeviceRouterComponent } from './modules/device/device-router/device-router.component';
import { DeviceSetupComponent } from './modules/device/device-setup/device-setup.component';
import { DeviceSetupMenuComponent } from './modules/device/device-setup-menu/device-setup-menu.component';
import { DeviceTabsComponent } from './modules/device/device-tabs/device-tabs.component';
import { UnconfiguredMetersComponent } from './modules/device/unconfigured-meters/unconfigured-meters.component';
import { EventsAlarmsMenuComponent } from './modules/events-alarms/events-alarms-menu/events-alarms-menu.component';
import { OnDemandAlarmCommandsComponent } from './modules/events-alarms/on-demand-alarm-commands/on-demand-alarm-commands.component';
import { OnDemandAlarmSetupComponent } from './modules/events-alarms/on-demand-alarm-commands/on-demand-alarm-setup/on-demand-alarm-setup.component';
import { RealTimeEventsComponent } from './modules/events-alarms/alarms/alarms.component';
import { CustomRegisterDetailsComponent } from './modules/on-demand-data-read/details/custom-register-details/custom-register-details.component';
import { EnergyDetailsComponent } from './modules/on-demand-data-read/details/energy-details/energy-details.component';
import { InstantaneousDetailsComponent } from './modules/on-demand-data-read/details/instantaneous-details/instantaneous-details.component';
import { EventLogDetailsComponent } from './modules/on-demand-data-read/details/event-log-details/event-log-details.component';
import { LoadProfileDetailsComponent } from './modules/on-demand-data-read/details/load-profile-details/load-profile-details.component';
import { PowerDemandDetailsComponent } from './modules/on-demand-data-read/details/power-demand-details/power-demand-details.component';
import { OnDemandCustomRegisterComponent } from './modules/on-demand-data-read/on-demand-custom-register/on-demand-custom-register.component';
import { OnDemandCustomRegisterSetupComponent } from './modules/on-demand-data-read/on-demand-custom-register-setup/on-demand-custom-register-setup';
import { OnDemandEnergyComponent } from './modules/on-demand-data-read/on-demand-energy/on-demand-energy.component';
import { OnDemandInstantaneousComponent } from './modules/on-demand-data-read/on-demand-instantaneous/on-demand-instantaneous.component';
import { OnDemandEventLogComponent } from './modules/on-demand-data-read/on-demand-event-log/on-demand-event-log.component';
import { OnDemandLoadProfileComponent } from './modules/on-demand-data-read/on-demand-load-profile/on-demand-load-profile.component';
import { OnDemandPowerDemandComponent } from './modules/on-demand-data-read/on-demand-power-demand/on-demand-power-demand.component';
import { OnDemandMenuComponent } from './modules/on-demand-data-read/on-demand-menu/on-demand-menu.component';
import { OnDemandSetupComponent } from './modules/on-demand-data-read/on-demand-setup/on-demand-setup.component';
import { ClearCreditComponent } from './modules/remote-command/clear-credit/clear-credit.component';
import { ClearCreditSetupComponent } from './modules/remote-command/clear-credit/clear-credit-setup/clear-credit-setup.component';
import { ClearTamperComponent } from './modules/remote-command/clear-tamper/clear-tamper.component';
import { ClearTamperSetupComponent } from './modules/remote-command/clear-tamper/clear-tamper-setup/clear-tamper-setup.component';
import { ConnectDisconnectComponent } from './modules/remote-command/connect-disconnect/connect-disconnect.component';
import { ConnectDisconnectSetupComponent } from './modules/remote-command/connect-disconnect/connect-disconnect-setup/connect-disconnect-setup.component';
import { RemoteCommandMenuComponent } from './modules/remote-command/remote-command-menu/remote-command-menu.component';
import { TokenLoadComponent } from './modules/remote-command/token-load/token-load.component';
import { TokenLoadSetupComponent } from './modules/remote-command/token-load/token-load-setup/token-load-setup.component';
import { TokenLoadTabsComponent } from './modules/remote-command/token-load-tabs/token-load-tabs.component';
import { ScheduledEnergyComponent } from './modules/scheduled-data-read/scheduled-energy/scheduled-energy.component';
import { ScheduledEnergyDetailsComponent } from './modules/scheduled-data-read/scheduled-energy-details/scheduled-energy-details.component';
import { ScheduledInstantaneousComponent } from './modules/scheduled-data-read/scheduled-instantaneous/scheduled-instantaneous.component';
import { ScheduledInstantaneousDetailsComponent } from './modules/scheduled-data-read/scheduled-instantaneous-details/scheduled-instantaneous-details.component';
import { ScheduledLoadProfileComponent } from './modules/scheduled-data-read/scheduled-load-profile/scheduled-load-profile.component';
import { ScheduledLoadProfileDetailsComponent } from './modules/scheduled-data-read/scheduled-load-profile-details/scheduled-load-profile-details.component';
import { ScheduledPowerDemandComponent } from './modules/scheduled-data-read/scheduled-power-demand/scheduled-power-demand.component';
import { ScheduledPowerDemandDetailsComponent } from './modules/scheduled-data-read/scheduled-power-demand-details/scheduled-power-demand-details.component';
import { ScheduledMenuComponent } from './modules/scheduled-data-read/scheduled-menu/scheduled-menu.component';
import { ScheduledEventLogsComponent } from './modules/scheduled-data-read/scheduled-event-logs/scheduled-event-logs.component';
import { ScheduledEventLogsDetailsComponent } from './modules/scheduled-data-read/scheduled-event-logs-details/scheduled-event-logs-details.component';
import { AuditLogsComponent } from './modules/settings/audit-logs/audit-logs.component';
import { CommunicationManagementComponent } from './modules/settings/communication-management/communication-management.component';
import { AreaManagementComponent } from './modules/settings/managements/area-management/area-management.component';
import { AssetTypeManagementComponent } from './modules/settings/managements/asset-type-management/asset-type-management.component';
import { MeterMakeManagementComponent } from './modules/settings/managements/meter-make-management/meter-make-management.component';
import { MeterModelAssociationsSetupComponent } from './modules/settings/managements/meter-model-management/meter-model-associations-setup/meter-model-associations-setup.component';
import { MeterModelManagementComponent } from './modules/settings/managements/meter-model-management/meter-model-management.component';
import { RegionManagementComponent } from './modules/settings/managements/region-management/region-management.component';
import { ServiceTypeManagementComponent } from './modules/settings/managements/service-type-management/service-type-management.component';
import { SchedulerComponent } from './modules/settings/scheduler/scheduler.component';
import { SchedulerManagementComponent } from './modules/settings/scheduler/scheduler-management/scheduler-management.component';
import { SchedulerMonitoringComponent } from './modules/settings/scheduler/scheduler-monitoring/scheduler-monitoring.component';
import { SchedulerRouterComponent } from './modules/settings/scheduler/scheduler-router/scheduler-router.component';
import { SchedulerSetupComponent } from './modules/settings/scheduler/scheduler-setup/scheduler-setup.component';
import { CrudRouterComponent } from './modules/settings/settings-crud/crud-router/crud-router.component';
import { SettingsCrudComponent } from './modules/settings/settings-crud/settings-crud.component';
import { SettingsMenuComponent } from './modules/settings/settings-menu/settings-menu.component';
import { RoleSetupComponent } from './modules/settings/team/role-setup/role-setup.component';
import { RolesPermissionsComponent } from './modules/settings/team/roles-permissions/roles-permissions.component';
import { TeamComponent } from './modules/settings/team/team.component';
import { TeamMemberSetupComponent } from './modules/settings/team/team-member-setup/team-member-setup.component';
import { TeamMembersComponent } from './modules/settings/team/team-members/team-members.component';
import { TeamRouterComponent } from './modules/settings/team/team-router/team-router.component';
import { UploadComponent } from './modules/settings/upload/upload.component';
import { AcquisitionComponent } from './modules/system-monitoring/acquisition/acquisition.component';
import { DeviceConnectionComponent } from './modules/system-monitoring/device-connection/device-connection.component';
import { MonitoringMenuComponent } from './modules/system-monitoring/monitoring-menu/monitoring-menu.component';
import { AuthGuard, BpsAdminGuard, PermissionGuard, UserGuard } from './services/guards/auth.guard';
import { SchedulerCommandsComponent } from './modules/settings/scheduler/scheduler-monitoring/scheduler-commands/scheduler-commands.component';
import { DesktopLoginComponent } from './modules/login/desktop-login/desktop-login.component';
import { UtilityManagementComponent } from './modules/utility/utility-management/utility-management.component';
import { UtilityRouterComponent } from './modules/utility/utility-router/utility-router.component';
import { UtilitySetupComponent } from './modules/utility/utility-setup/utility-setup.component';
import { UtilityComponent } from './modules/utility/utility.component';
import { BpsDashboardComponent } from './modules/bps-dashboard/bps-dashboard.component';
import { TariffManagementComponent } from './modules/tariff/tariff-management/tariff-management.component';
import { TariffSetupComponent } from './modules/tariff/tariff-setup/tariff-setup.component';
import { TariffSetupMenuComponent } from './modules/tariff/tariff-setup-menu/tariff-setup-menu.component';
import { MeterModelEventCodesComponent } from './modules/settings/managements/meter-model-management/meter-model-event-codes/meter-model-event-codes.component';
import { MeterModelVersionsComponent } from './modules/settings/managements/meter-model-management/meter-model-versions/meter-model-versions.component';
import { DeviceManagementComponent } from './modules/device/device-management/device-management.component';
import { FirmwareUpdateGroupComponent } from './modules/device/firmware-update-group/firmware-update-group.component';
import { EventsComponent } from './modules/events-alarms/events/events.component';
import { LoadLimitComponent } from './modules/load-limit/load-limit.component';
import { LoadLimitSetupComponent } from './modules/load-limit/load-limit-setup/load-limit-setup.component';
import { JobStatusHistoryComponent } from './modules/system-monitoring/job-status-history/job-status-history.component';
import { SequentialTokenLoadComponent } from './modules/remote-command/sequential-token-load/sequential-token-load.component';
import { SequentialTokenLoadSetupComponent } from './modules/remote-command/sequential-token-load/sequential-token-load-setup/sequential-token-load-setup.component';
import { FirmwareUpdateGroupDetailsComponent } from './modules/device/firmware-update-group/details/firmware-update-group-details/firmware-update-group-details.component';
import { CreateRegionBasedFirmwareUpdateComponent } from './modules/device/firmware-update-group/create-region-based-firmware-update/create-region-based-firmware-update.component';
import { BulkDownloadComponent } from './modules/scheduled-data-read/bulk-download/bulk-download.component';
import { DeviceDetailsComponent } from './modules/device/device-management/device-details/device-details.component';
import { MeterSetupDesktopAppComponent } from './modules/desktop-app/meter-setup-desktop-app/meter-setup-desktop-app.component';

export const routes: Routes = [
  {
    path: '',
    component: PrivateLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'analytics',
        pathMatch: 'full',
      },
      {
        path: 'bps-analytics',
        component: BpsDashboardComponent,
        canActivate: [BpsAdminGuard],
        data: { breadcrumb: 'ANALYTICS' },
      },
      {
        path: 'analytics',
        component: AnalyticsComponent,
        canActivate: [UserGuard],
        data: { breadcrumb: 'ANALYTICS' },
      },
      {
        path: 'devices',
        component: DeviceRouterComponent,
        data: {
          requiredPermission: [PermissionsEnum.Device_view],
        },
        canActivate: [PermissionGuard],
        children: [
          {
            path: 'details/:meterId',
            component: DeviceDetailsComponent,
          },
          {
            path: '',
            component: DeviceTabsComponent,
            children: [
              {
                path: 'all-devices',
                component: DeviceManagementComponent,
                data: {
                  breadcrumb: 'DEVICES_TITLE',
                  requiredPermission: [PermissionsEnum.Device_view],
                },
                canActivate: [PermissionGuard]
              },
              {
                path: 'recently-added',
                component: DeviceManagementComponent,
                data: {
                  breadcrumb: 'DEVICES_RECENTLYADDED',
                  requiredPermission: [PermissionsEnum.Device_view],
                  filterToday: true,
                },
                canActivate: [PermissionGuard],
              },
              {
                path: 'uncofigured-meters',
                component: UnconfiguredMetersComponent,
                data: {
                  breadcrumb: 'DEVICES_UNCONFIGURED',
                  requiredPermission: [PermissionsEnum.Device_view],
                },
                canActivate: [PermissionGuard],
              },
            ],
          },
        ],
      },
      {
        path: 'device-setup',
        component: DeviceSetupMenuComponent,
        data: {
          breadcrumb: 'SIDEBAR_DEVICES',
          requiredPermission: [PermissionsEnum.Device_add],
        },
        canActivate: [PermissionGuard],
        children: [
          {
            path: '',
            component: DeviceSetupComponent,
            data: {
              breadcrumb: 'DEVICES_MENU_DEVICESETUP',
              requiredPermission: [PermissionsEnum.Device_add],
            },
            canActivate: [PermissionGuard],
          }
        ],
      },
      {
        path: 'firmware-update-group',
        component: FirmwareUpdateGroupComponent,
        data: {
          breadcrumb: 'FIRMWARE_UPDATE_GROUP_TITLE',
          requiredPermission: [PermissionsEnum.Device_firmware_update],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'firmware-update-group/update-by-location',
        component: CreateRegionBasedFirmwareUpdateComponent,
        data: {
          breadcrumb: 'FIRMWARE_UPDATE',
          requiredPermission: [PermissionsEnum.Device_firmware_update],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'firmware-update-group/details/:id',
        component: FirmwareUpdateGroupDetailsComponent,
        data: {
          breadcrumb: 'FIRMWARE_UPDATE_GROUP_TITLE',
          requiredPermission: [PermissionsEnum.Device_firmware_update],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'utilities',
        component: UtilityRouterComponent,
        canActivate: [BpsAdminGuard],
        children: [
          {
            path: '',
            component: UtilityComponent,
            children: [
              {
                path: 'all',
                component: UtilityManagementComponent,
                data: {
                  breadcrumb: 'UTILITIES',
                },
                canActivate: [BpsAdminGuard],
              },
            ],
          },
          {
            path: 'utility-setup',
            component: UtilitySetupComponent,
            data: {
              breadcrumb: 'UTILITIES',
            },
            canActivate: [BpsAdminGuard],
          },
        ],
      },
      {
        path: 'events',
        component: EventsAlarmsMenuComponent,
        data: { breadcrumb: 'EVENTTRIGGERS' },
        children: [
          {
            path: '',
            redirectTo: 'events',
            pathMatch: 'full',
          },
          {
            path: 'alarms',
            component: RealTimeEventsComponent,
            data: {
              breadcrumb: 'REALTIMEALARMS',
              requiredPermission: [PermissionsEnum.Alarms_realtime_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'on-demand-setup',
            component: OnDemandAlarmSetupComponent,
            data: {
              breadcrumb: 'ONDEMANDEVENT',
              requiredPermission: [PermissionsEnum.Alarms_ondemand_execute],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'on-demand',
            component: OnDemandAlarmCommandsComponent,
            data: {
              breadcrumb: 'ONDEMANDEVENT',
              requiredPermission: [PermissionsEnum.Alarms_ondemand_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'events',
            component: EventsComponent,
            data: {
              breadcrumb: 'SIDEBAR_EVENTS',
              requiredPermission: [PermissionsEnum.Alarms_events_view]
            }
          }
        ],
      },
      {
        path: 'billing-data',
        component: OnDemandBillingDataComponent,
        data: {
          breadcrumb: 'LOADPROFILEMANU_BILLINGDATA',
          requiredPermission: [PermissionsEnum.Ondemand_billingdata_view],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'billing-data-setup',
        component: OnDemandSetupComponent,
        data: {
          breadcrumb: 'ONDEMANDCAPS',
          requiredPermission: [PermissionsEnum.Ondemand_billingdata_execute],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'billing-data-details',
        component: BillingDataDetailsComponent,
        data: {
          breadcrumb: 'DETAILS',
          requiredPermission: [PermissionsEnum.Ondemand_billingdata_view],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'on-demand',
        component: OnDemandMenuComponent,
        data: { breadcrumb: 'SIDEBAR_ONDEMANDDATAREAD' },
        children: [
          {
            path: '',
            redirectTo: 'load-profile',
            pathMatch: 'full',
          },
          {
            path: 'energy-setup',
            component: OnDemandSetupComponent,
            data: {
              breadcrumb: 'ONDEMANDCAPS',
              requiredPermission: [
                PermissionsEnum.Ondemand_energyregister_execute,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'power-demand-setup',
            component: OnDemandSetupComponent,
            data: {
              breadcrumb: 'ONDEMANDCAPS',
              requiredPermission: [
                PermissionsEnum.Ondemand_powerdemandregister_execute,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'instantaneous-object-setup',
            component: OnDemandSetupComponent,
            data: {
              breadcrumb: 'ONDEMANDCAPS',
              requiredPermission: [
                PermissionsEnum.Ondemand_instantaneousobject_execute,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'load-profile-setup',
            component: OnDemandSetupComponent,
            data: {
              breadcrumb: 'ONDEMANDCAPS',
              requiredPermission: [
                PermissionsEnum.Ondemand_loadprofile_execute,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'event-log-setup',
            component: OnDemandSetupComponent,
            data: {
              breadcrumb: 'ONDEMANDCAPS',
              requiredPermission: [
                PermissionsEnum.Ondemand_event_log_execute,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'custom-register-setup',
            component: OnDemandCustomRegisterSetupComponent,
            data: {
              breadcrumb: 'ONDEMANDCAPS',
              requiredPermission: [
                PermissionsEnum.Ondemand_generic_register_execute,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'energy',
            component: OnDemandEnergyComponent,
            data: {
              breadcrumb: 'GETENERGYREGISATER',
              requiredPermission: [
                PermissionsEnum.Ondemand_energyregister_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'power-demand',
            component: OnDemandPowerDemandComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_MAXDEMANDREGISTRES',
              requiredPermission: [
                PermissionsEnum.Ondemand_powerdemandregister_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'load-profile',
            component: OnDemandLoadProfileComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_GETLOADPROFILE',
              requiredPermission: [PermissionsEnum.Ondemand_loadprofile_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'event-log',
            component: OnDemandEventLogComponent,
            data: {
              breadcrumb: 'EVENTLOGMENU_GETEVENTLOG',
              requiredPermission: [PermissionsEnum.Ondemand_event_log_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'instantaneous-object',
            component: OnDemandInstantaneousComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_INSTANTANEUSOBJECT',
              requiredPermission: [
                PermissionsEnum.Ondemand_instantaneousobject_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'custom-register',
            component: OnDemandCustomRegisterComponent,
            data: {
              breadcrumb: 'LOADPROFILEMENU_CUSTOMREGISTER',
              requiredPermission: [
                PermissionsEnum.Ondemand_generic_register_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'energy-details',
            component: EnergyDetailsComponent,
            data: {
              breadcrumb: 'DETAILS',
              requiredPermission: [
                PermissionsEnum.Ondemand_energyregister_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'power-demand-details',
            component: PowerDemandDetailsComponent,
            data: {
              breadcrumb: 'DETAILS',
              requiredPermission: [
                PermissionsEnum.Ondemand_powerdemandregister_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'load-profile-details',
            component: LoadProfileDetailsComponent,
            data: {
              breadcrumb: 'DETAILS',
              requiredPermission: [
                PermissionsEnum.Ondemand_loadprofile_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'event-log-details',
            component: EventLogDetailsComponent,
            data: {
              breadcrumb: 'DETAILS',
              requiredPermission: [
                PermissionsEnum.Ondemand_event_log_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'instantaneous-object-details',
            component: InstantaneousDetailsComponent,
            data: {
              breadcrumb: 'DETAILS',
              requiredPermission: [
                PermissionsEnum.Ondemand_instantaneousobject_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'custom-register-details',
            component: CustomRegisterDetailsComponent,
            data: {
              breadcrumb: 'DETAILS',
              requiredPermission: [
                PermissionsEnum.Ondemand_generic_register_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
        ],
      },
      {
        path: 'account',
        component: AccountMenuComponent,
        data: { breadcrumb: 'SIDEBAR_ACCOUNT' },
        children: [
          {
            path: '',
            redirectTo: 'profile',
            pathMatch: 'full',
          },
          {
            path: 'language',
            component: AccountLanguageComponent,
            data: {
              breadcrumb: 'LANGUAGE',
              requiredPermission: [PermissionsEnum.Personalize_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'profile',
            component: AccountProfileComponent,
            data: {
              breadcrumb: 'PROFILE',
            },
          },
          {
            path: 'appearance',
            component: AccountAppearanceComponent,
            data: {
              breadcrumb: 'APPEARANCE',
              requiredPermission: [PermissionsEnum.Personalize_view],
            },
            canActivate: [PermissionGuard],
          },
        ],
      },
      {
        path: 'scheduled',
        component: ScheduledMenuComponent,
        data: { breadcrumb: 'SIDEBAR_LOADPROFILE' },
        children: [
          {
            path: '',
            redirectTo: 'load-profile',
            pathMatch: 'full',
          },
          {
            path: 'energy',
            component: ScheduledEnergyComponent,
            data: {
              breadcrumb: 'GETENERGYREGISATER',
              requiredPermission: [
                PermissionsEnum.Scheduled_energyregister_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'energy-details',
            component: ScheduledEnergyDetailsComponent,
            data: {
              breadcrumb: 'GETENERGYREGISATER',
              requiredPermission: [
                PermissionsEnum.Scheduled_energyregister_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'power-demand',
            component: ScheduledPowerDemandComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_MAXDEMANDREGISTRES',
              requiredPermission: [
                PermissionsEnum.Scheduled_powerdemandregister_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'power-demand-details',
            component: ScheduledPowerDemandDetailsComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_MAXDEMANDREGISTRES',
              requiredPermission: [
                PermissionsEnum.Scheduled_powerdemandregister_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'load-profile',
            component: ScheduledLoadProfileComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_GETLOADPROFILE',
              requiredPermission: [PermissionsEnum.Scheduled_loadprofile_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'load-profile-details',
            component: ScheduledLoadProfileDetailsComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_GETLOADPROFILE',
              requiredPermission: [PermissionsEnum.Scheduled_loadprofile_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'instantaneous-object',
            component: ScheduledInstantaneousComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_INSTANTANEUSOBJECT',
              requiredPermission: [
                PermissionsEnum.Scheduled_instantaneousobject_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'instantaneous-object-details',
            component: ScheduledInstantaneousDetailsComponent,
            data: {
              breadcrumb: 'LOADPROFILEMANU_INSTANTANEUSOBJECT',
              requiredPermission: [
                PermissionsEnum.Scheduled_instantaneousobject_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'event-logs',
            component: ScheduledEventLogsComponent,
            data: {
              breadcrumb: 'EVENT_LOG_DATA',
              requiredPermission: [PermissionsEnum.Scheduled_event_log_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'event-logs-details',
            component: ScheduledEventLogsDetailsComponent,
            data: {
              breadcrumb: 'EVENT_LOG_DATA',
              requiredPermission: [PermissionsEnum.Scheduled_event_log_view],
            },
            canActivate: [PermissionGuard],
          },
        ],
      },
      {
        path: 'system-monitoring',
        component: MonitoringMenuComponent,
        data: { breadcrumb: 'SIDEBAR_SYSTEMMONITORING' },
        children: [
          {
            path: '',
            redirectTo: 'acquisition',
            pathMatch: 'full',
          },
          {
            path: 'acquisition',
            component: AcquisitionComponent,
            data: {
              breadcrumb: 'MONITORING_ACQUISITION',
              requiredPermission: [
                PermissionsEnum.Systemmonitoring_acquisition_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'device-connection-time',
            component: DeviceConnectionComponent,
            data: {
              breadcrumb: 'MONITORING_DEVICECONNECTION',
              requiredPermission: [
                PermissionsEnum.Systemmonitoring_deviceconnectiontime_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'job-status-history',
            component: JobStatusHistoryComponent,
            data: {
              breadcrumb: 'JOBSTATUSHISTORY_TITLE',
              requiredPermission: [
                PermissionsEnum.Scheduler_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
        ],
      },
      {
        path: 'remote-command',
        component: RemoteCommandMenuComponent,
        data: { breadcrumb: 'SIDEBAR_REMOTECOMMAND' },
        children: [
          {
            path: '',
            redirectTo: 'connect-disconnect',
            pathMatch: 'full',
          },
          {
            path: 'connect-disconnect',
            component: ConnectDisconnectComponent,
            data: {
              breadcrumb: 'REMOTECOMMAND-CONNECTDISCONNECT',
              requiredPermission: [
                PermissionsEnum.Remotecommands_connectdisconnect_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'connect-disconnect-setup',
            component: ConnectDisconnectSetupComponent,
            data: {
              breadcrumb: 'CONNDISCONN_SETUP',
              requiredPermission: [
                PermissionsEnum.Remotecommands_connectdisconnect_execute,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'token-load',
            component: TokenLoadTabsComponent,
            data: { breadcrumb: 'REMOTECOMMAND_TOKENLOAD' },
            children: [
              {
                path: '',
                redirectTo: 'token-load',
                pathMatch: 'full',
              },
              {
                path: 'token-load',
                component: TokenLoadComponent,
                data: {
                  breadcrumb: 'REMOTECOMMAND_CREDITTOKEN',
                  requiredPermission: [PermissionsEnum.Remotecommands_tokenload_view],
                },
                canActivate: [PermissionGuard],
              },
              {
                path: 'clear-credit',
                component: ClearCreditComponent,
                data: {
                  breadcrumb: 'REMOTECOMMAND_CLEARCREDIT',
                  requiredPermission: [PermissionsEnum.Remotecommands_clearcredit_view],
                },
                canActivate: [PermissionGuard],
              },
              {
                path: 'clear-tamper',
                component: ClearTamperComponent,
                data: {
                  breadcrumb: 'REMOTECOMMAND_CLEARTAMPER',
                  requiredPermission: [PermissionsEnum.Remotecommands_cleartamper_view],
                },
                canActivate: [PermissionGuard],
              },
            ],
          },
          {
            path: 'token-load-setup',
            component: TokenLoadSetupComponent,
            data: {
              breadcrumb: 'Token Load Setup',
              requiredPermission: [PermissionsEnum.Remotecommands_tokenload_execute],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'clear-credit-setup',
            component: ClearCreditSetupComponent,
            data: {
              breadcrumb: 'CLEARCREDIT_SETUP',
              requiredPermission: [PermissionsEnum.Remotecommands_clearcredit_execute],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'clear-tamper-setup',
            component: ClearTamperSetupComponent,
            data: {
              breadcrumb: 'CLEARTAMPER_SETUP',
              requiredPermission: [PermissionsEnum.Remotecommands_cleartamper_execute],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'sequential-token-load',
            component: SequentialTokenLoadComponent,
            data: {
              breadcrumb: 'SEQUENTIALTOKENLOAD_TITLE',
              requiredPermission: [PermissionsEnum.Remotecommands_sequentialtokenload_view]
            },
            canActivate: [PermissionGuard]
          },
          {
            path: 'sequential-token-load-setup',
            component: SequentialTokenLoadSetupComponent,
            data: {
              breadcrumb: 'SEQUENTIALTOKENLOAD_TITLE',
              requiredPermission: [PermissionsEnum.Remotecommands_sequentialtokenload_execute]
            },
            canActivate: [PermissionGuard]
          }
        ],
      },
      {
        path: 'load-limit',
        component: LoadLimitComponent,
        data: {
          breadcrumb: 'SIDEBAR_LOADLIMITMANAGEMENT',
          requiredPermission: [PermissionsEnum.Loadlimit_view],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'load-limit-setup',
        component: LoadLimitSetupComponent,
        data: {
          breadcrumb: 'LOADLIMITSETUP',
          requiredPermission: [
            PermissionsEnum.Loadlimit_add,
          ],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'settings',
        component: SettingsMenuComponent,
        data: { breadcrumb: 'SIDEBAR_SETTINGS' },
        children: [
          {
            path: '',
            redirectTo: 'crud',
            pathMatch: 'full',
          },
          {
            path: 'communication-management',
            component: CommunicationManagementComponent,
            data: {
              breadcrumb: 'COMMUNICATION_MANAGEMENT',
            },
          },
          {
            path: 'crud',
            component: CrudRouterComponent,
            children: [
              {
                path: '',
                component: SettingsCrudComponent,
                data: { breadcrumb: 'CRUD' },
                children: [
                  {
                    path: 'region',
                    component: RegionManagementComponent,
                    data: {
                      breadcrumb: 'DEVICESETUP_REGION',
                      requiredPermission: [
                        PermissionsEnum.Settings_crud_region_view,
                      ],
                    },
                    canActivate: [PermissionGuard],
                  },
                  {
                    path: 'area',
                    component: AreaManagementComponent,
                    data: {
                      breadcrumb: 'DEVICESETUP_AREA',
                      requiredPermission: [
                        PermissionsEnum.Settings_crud_area_view,
                      ],
                    },
                    canActivate: [PermissionGuard],
                  },
                  {
                    path: 'service-type',
                    component: ServiceTypeManagementComponent,
                    data: {
                      breadcrumb: 'DEVICESETUP_SERVICETYPE',
                      requiredPermission: [
                        PermissionsEnum.Settings_crud_servicetype_view,
                      ],
                    },
                    canActivate: [PermissionGuard],
                  },
                  {
                    path: 'meter-make',
                    component: MeterMakeManagementComponent,
                    data: {
                      breadcrumb: 'DEVICESETUP_METERMAKE',
                      requiredPermission: [
                        PermissionsEnum.Settings_crud_metermake_view,
                      ],
                    },
                    canActivate: [PermissionGuard],
                  },
                  {
                    path: 'meter-model',
                    component: MeterModelManagementComponent,
                    data: {
                      breadcrumb: 'DEVICESETUP_METERMODEL',
                      requiredPermission: [
                        PermissionsEnum.Settings_crud_metermodel_view,
                      ],
                    },
                    canActivate: [PermissionGuard],
                  },

                  {
                    path: 'asset-type',
                    component: AssetTypeManagementComponent,
                    data: {
                      breadcrumb: 'DEVICESETUP_ASSETTYPE',
                      requiredPermission: [
                        PermissionsEnum.Settings_crud_assettype_view,
                      ],
                    },
                    canActivate: [PermissionGuard],
                  },

                ],
              },
              {
                path: 'meter-model-version/:id',
                component: MeterModelVersionsComponent,
                data: {
                  breadcrumb: 'DEVICESETUP_METERMODEL',
                  requiredPermission: [
                    PermissionsEnum.Settings_crud_metermodel_view,
                  ],
                },
                canActivate: [PermissionGuard],
              },
              {
                path: 'meter-model-event-codes/:id',
                component: MeterModelEventCodesComponent,
                data: {
                  breadcrumb: 'EVENT_CODES',
                  requiredPermission: [
                    PermissionsEnum.Settings_crud_metermodel_view,
                  ],
                },
                canActivate: [PermissionGuard],
              },
              {
                path: 'meter-model-associations-setup',
                component: MeterModelAssociationsSetupComponent,
                data: {
                  breadcrumb: 'DEVICESETUP_METERMODEL',
                  requiredPermission: [
                    PermissionsEnum.Settings_crud_metermodel_view,
                  ],
                },
                canActivate: [PermissionGuard],
              },
            ],
          },
          {
            path: 'team',
            component: TeamRouterComponent,

            children: [
              {
                path: '',
                component: TeamComponent,
                data: {
                  breadcrumb: 'TEAM',
                },
                children: [
                  {
                    path: 'members',
                    component: TeamMembersComponent,
                    data: {
                      breadcrumb: 'TEAMMEMBER',
                      requiredPermission: [
                        PermissionsEnum.Settings_team_member_view,
                      ],
                    },
                  },
                  {
                    path: 'roles-permissions',
                    component: RolesPermissionsComponent,
                    data: {
                      breadcrumb: 'ROLESPERMISSIONS',
                      requirePerimission: [
                        PermissionsEnum.Settings_team_role_view,
                      ],
                    },
                  },
                ],
              },
              {
                path: 'team-setup',
                component: TeamMemberSetupComponent,
                data: {
                  breadcrumb: 'TEAMSETUP',
                  requiredPermission: [
                    PermissionsEnum.Settings_team_member_modify,
                  ],
                },
                canActivate: [PermissionGuard],
              },
              {
                path: 'role-setup',
                component: RoleSetupComponent,
                data: {
                  breadcrumb: 'ROLESETUP',
                  requiredPermission: [
                    PermissionsEnum.Settings_team_role_modify,
                  ],
                },
                canActivate: [PermissionGuard],
              },
            ],
          },
          {
            path: 'scheduler',
            component: SchedulerRouterComponent,

            children: [
              {
                path: '',
                component: SchedulerComponent,
                children: [
                  {
                    path: 'schedules',
                    component: SchedulerManagementComponent,
                    data: {
                      breadcrumb: 'SCHEDULER',
                      requiredPermission: [
                        PermissionsEnum.Settings_team_member_view,
                      ],
                    },
                    canActivate: [PermissionGuard],
                  },
                ],
              },
              {
                path: 'schedule-setup',
                component: SchedulerSetupComponent,
                data: {
                  breadcrumb: 'METERMODELSETUP',
                  requiredPermission: [
                    PermissionsEnum.Settings_team_member_modify,
                  ],
                },
                canActivate: [PermissionGuard],
              },
              {
                path: 'monitoring',
                component: SchedulerMonitoringComponent,
                data: {
                  breadcrumb: 'Schedule Logs',
                  requiredPermission: [
                    PermissionsEnum.Scheduler_monitoring,
                  ],
                },
                canActivate: [PermissionGuard],
              },
              {
                path: 'commands',
                component: SchedulerCommandsComponent,
                data: {
                  breadcrumb: "Scheduler Logs Commands",
                  requiredPermission: [
                    PermissionsEnum.Scheduler_monitoring,
                  ],
                },
                canActivate: [PermissionGuard],
              }
            ],
          },

          {
            path: 'audit-logs',
            component: AuditLogsComponent,
            data: {
              breadcrumb: 'Audit Logs',
              requiredPermission: [
                PermissionsEnum.Auditlog_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
        ],
      },
      {
        path: 'upload/:entity',
        component: UploadComponent,
        data: {
          breadcrumb: 'UPLOAD',
          requiredPermission: [PermissionsEnum.Device_bulk_upload],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'analysis-report',
        component: AnalysisReportMenuComponent,
        data: { breadcrumb: 'SIDEBAR_ANALYSIS_REPORT' },
        children: [
          {
            path: '',
            redirectTo: 'fraudulent-meters',
            pathMatch: 'full',
          },
          {
            path: 'fraudulent-meters',
            component: FraudulentMetersComponent,
            data: {
              breadcrumb: 'ANALYSISREPORTMENU_GETFRAUDULENTMETERS',
              requiredPermission: [
                PermissionsEnum.Report_fraudulent_meters_view,
              ],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'pre-payment-report',
            component: PrePaymentReportComponent,
            data: {
              breadcrumb: 'ANALYSISREPORTMENU_PREPAYMENTREPORT',
              requiredPermission: [PermissionsEnum.Report_prepayment_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'meter-time-sync',
            component: MeterTimeSyncComponent,
            data: {
              breadcrumb: 'METERTIMESYNC',
              requiredPermission: [PermissionsEnum.Report_meter_time_sync_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'energy-per-phase',
            component: EnergyPerPhaseComponent,
            data: {
              breadcrumb: 'REPORT_ENERGYPERPHASE',
              requiredPermission: [PermissionsEnum.Scheduled_loadprofile_view],
            },
            canActivate: [PermissionGuard],
          },
          {
            path: 'energy-per-phase-details',
            component: EnergyPerPhaseDetailsComponent,
            data: {
              breadcrumb: 'REPORT_ENERGYPERPHASE',
              requiredPermission: [PermissionsEnum.Scheduled_loadprofile_view],
            },
            canActivate: [PermissionGuard],
          }
        ],
      },
      {
        path: 'tariffs',
        component: TariffManagementComponent,
        data: {
          breadcrumb: 'TARIFFS_TITLE',
          requiredPermission: [PermissionsEnum.Device_view],
        },
        canActivate: [PermissionGuard],
      },
      {
        path: 'tariff-setup',
        component: TariffSetupMenuComponent,
        data: {
          breadcrumb: 'SIDEBAR_TARIFFS',
          requiredPermission: [PermissionsEnum.Device_add]
        },
        canActivate: [PermissionGuard],
        children: [
          {
            path: '',
            component: TariffSetupComponent,
            data: {
              breadcrumb: 'TARIFFS_MENU_TARIFFSETUP',
              requiredPermission: [PermissionsEnum.Device_add],
            },
            canActivate: [PermissionGuard],
          },
        ],
      },
      {
        path: 'bulk-download',
        component: BulkDownloadComponent,
      },
      {
        path: 'meter-setup-desktop-app',
        component: MeterSetupDesktopAppComponent,
        data: {
          breadcrumb: 'METER_SETUP_DESKTOP_APP',
        },
      },

    ],
  },
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: LoginComponent,
        data: { isAdmin: false },
        pathMatch: 'full',
      },
      {
        path: 'desktop-login',
        component: DesktopLoginComponent,
        data: { isAdmin: false },
        pathMatch: 'full',
      },
      { path: 'process-login', component: ProcessLoginComponent },
    ],
  },
  {
    path: 'healthcheck',
    component: HealthCheckComponent,
  },
];
